let Environment = {
  // backendUrl: "api.mezada.net/", //staging url
  backendUrl: "https://api.mezada.net/", //production url
  // backendUrl : "http://192.168.30.134:9000/admin",    // local backend URL
};

export default Environment;